module.exports = __webpack_public_path__ + "static/media/Close.4221c946.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/icons/Close.svg
// module id = 49
// module chunks = 0